<template>
  <div class="h-screen flex w-full bg-img vx-row items-center justify-center" id="page-login">
      <div class="vx-col">
          <vx-card>
              <div slot="no-body" class="full-page-bg-color">
                  <div class="vx-col d-theme-dark-bg">
                      <div class="p-8 login-tabs-container">

                          <div class="vx-card__title mb-4">
                              <center class="mb-4">
                                  <img src="logo.png" alt="logo" width="81px" height="81px">
                              </center>
                              <p>{{ message }}</p><br><br>
                          </div>
                      </div>
                  </div>
              </div>
          </vx-card>
      </div>
  </div>
</template>

<script>
  import auth from "../../helper/auth";
  export default{
      data() {
        return {
          message: 'Veuillez patienter pendant la vérification'
        }
      },
      mounted(){
        const query = this.$route.query;
        if (query.code){
          this.login(query.code);
        }else{
          this.$vs.notify({
            time: 2000,
            title: 'Error',
            text: "Impossible de procéder à cette opération.",
            color: 'danger',
            iconPack: 'feather',
            position: 'top-right',
            icon: 'icon-check-circle'
          });
          this.$router.push('/login');
        }
      },
      methods:{

        login(code){
            this.$vs.loading()
            this.$http.post('auth/login/ad', { code }).then((response) =>{
                this.$vs.loading.close()
                if (response.data.status){
                  auth.authenticate(response.data)
                  this.errors = []
                  if (response.data.user.profile == '1'){
                    this.$router.push({name: 'payments'})
                  }else this.$router.push('/')
                }else{
                  this.message = "Impossible de vérifier votre compte.";
                  this.$vs.notify({
                    time: 2000,
                    title: 'Error',
                    text: "Impossible de vérifier votre compte.",
                    color: 'danger',
                    iconPack: 'feather',
                    position: 'top-right',
                    icon: 'icon-check-circle'
                  });
                  setTimeout(() => {
                    this.$router.replace('/login');
                  }, 400);
                }
            }).catch((error) => {
                this.$vs.loading.close()
                this.errors = error.response.data.errors
            })
        }
      }
  }
</script>

<style lang="scss">
  #page-login {
      .social-login-buttons {
          .bg-facebook { background-color: #1551b1 }
          .bg-twitter { background-color: #00aaff }
          .bg-google { background-color: #4285F4 }
          .bg-github { background-color: #333 }
      }
  }
  .i-toggle{
    display: flex;
    flex-direction: row;
  }
  .toggle-icon{
    margin-left: -23px;
    padding-top: 9px;
  }
</style>
